const IconChevronRight = ({ className }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 25' fill='none' className={className}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.29287 5.5225C8.68336 5.13198 9.31648 5.13198 9.70697 5.5225L15.7065 11.5225C16.097 11.913 16.097 12.5462 15.7065 12.9367L9.70697 18.9367C9.31648 19.3272 8.68336 19.3272 8.29287 18.9367C7.90238 18.5462 7.90238 17.913 8.29287 17.5225L13.5853 12.2296L8.29287 6.93671C7.90238 6.54619 7.90238 5.91302 8.29287 5.5225Z'
            />
        </svg>
    );
};

export default IconChevronRight;
